import React, { Component, Fragment } from "react";
import ContainerDimensions from "react-container-dimensions";
import WithCard from "../../../../common/withCard";
// import StackedAreaChart from "../../../../d3Components/StackedArea/StackedAreaChartWithAxis";
import Legend from "../../../../d3Components/legend";
import AreaChartWithAxis from "../../../../d3Components/multiAreaChart/AreaChartWithAxis";
// import Portfolio from "./portfolio.json";
// import Benchmark from "./benchmark.json";

class DrawDown extends Component {
  state = {
    data: [],
    getPortfolioVami: [],
    getBenchmarkVami: [],
  };

  componentDidMount() {
    const { getPortfolioVami, getBenchmarkVami } = this.props;
    // let newData = this.dataModify(getPortfolioVami, getBenchmarkVami);
    // let newData = this.dataModify(Portfolio, Benchmark);

    this.setState({
      // data: newData,
      getPortfolioVami,
      getBenchmarkVami,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { getPortfolioVami, getBenchmarkVami } = nextProps;
    // let newData = this.dataModify(getPortfolioVami, getBenchmarkVami);
    // let newData = this.dataModify(Portfolio, Benchmark);

    this.setState({
      // data: newData,
      getPortfolioVami,
      getBenchmarkVami,
    });
  }
  // dataModify = (portfolio, benchmark) => {
  //   let finalData = [];

  //   let max_length = Math.max(benchmark.length, portfolio.length);

  //   for (let i = 0; i < max_length; i++) {
  //     let obj = {};
  //     let obj2 = {};

  //     obj["key"] = "benchmak";
  //     obj["date"] = benchmark[i]["dt"];
  //     obj["value"] = benchmark[i]["drawdown"] * 1;

  //     obj2["key"] = "portfolio";
  //     obj2["date"] =
  //       i < portfolio.length ? portfolio[i]["dt"] : benchmark[i]["dt"];
  //     obj2["value"] = i < portfolio.length ? portfolio[i]["drawdown"] * 1 : "";
  //     finalData.push(obj);
  //     finalData.push(obj2);
  //   }

  //   return finalData;
  // };
  render() {
    // const { data } = this.state;
    const { getPortfolioVami, getBenchmarkVami } = this.state;
    const {
      benchmark_name,
      display_orig_portfolio,
      getOrigPortfolioVami,
      model_name,
    } = this.props;

    return (
      <Fragment>
        {/* {data.length > 0 ? (
        <div className="draw-down">
          <WithCard>
            <h4 className="text-uppercase bold">Drawdown </h4>
            <svg height={30} width={500}>
              <Legend
                // legend1={props.newBenchmarkName ? "IQCIO portfolio" : null}
                legend1={"Portfolio"}
                legend2={"Benchmark"}
              />
            </svg>
            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  {width > 0 ? (
                    <StackedAreaChart
                      chartId="Stacked2"
                      width={width - 100}
                      height={300}
                      data={data}
                    />
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
          </WithCard>
        </div>
        ) : null}  */}

        {getPortfolioVami.length > 0 && getBenchmarkVami.length > 0 ? (
          <WithCard>
            <h4 className="text-uppercase bold">Drawdown </h4>

            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  {width > 0 ? (
                    <Fragment>
                      <Legend
                        height={30}
                        width={width}
                        // legend1={props.newBenchmarkName ? "IQCIO portfolio" : null}
                        legend1={
                          display_orig_portfolio
                            ? `IQCIO Model ${model_name ? "+" : ""}`
                            : "Portfolio"
                        }
                        legend2={
                          display_orig_portfolio ? "Benchmark *" : "Benchmark"
                        }
                        legend3={
                          display_orig_portfolio ? "Original Portfolio" : ""
                        }
                      />
                      <AreaChartWithAxis
                        id={"areaChart_01"}
                        Portfolio={getPortfolioVami}
                        Benchmark={getBenchmarkVami}
                        getOrigPortfolioVami={getOrigPortfolioVami}
                        width={width - 100}
                        height={400}
                        display_orig_portfolio={display_orig_portfolio}
                      />
                      <div>
                        {display_orig_portfolio ? (
                          <Fragment>
                            <small>
                              <b>*</b>&nbsp;
                              {benchmark_name}
                            </small>
                          </Fragment>
                        ) : null}
                      </div>
                      {model_name ? (
                        <div>
                          <small>
                            <b>+</b>&nbsp;
                            {model_name}
                          </small>
                        </div>
                      ) : null}
                    </Fragment>
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
          </WithCard>
        ) : null}
      </Fragment>
    );
  }
}
export default DrawDown;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/drawDown/DrawDown.jsx